import { createElement, useMemo, useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import Ticks from './ticks';
import Marks from './marks';
import Thumb from './thumb';
import { nearest } from '../../utils/nearest';
import './index.scss';
const ColorfulDragbar = props => {
    const { min, max, value, step, marks, onChange, ...otherProps } = props;
    const [sliderValue, setSliderValue] = useState();
    const [fillSize, setFillSize] = useState();
    const [showNum, setShowNum] = useState(false);
    const trackRef = useRef(null);
    const classPrefix = `au-dragbar`;
    useEffect(() => {
        setSliderValue(value);
        const FillVal = `${(100 * (value - min)) / (max - min)}%`;
        setFillSize(FillVal);
    }, [value]);
    useEffect(() => {
        const FillVal = `${(100 * (sliderValue - min)) / (max - min)}%`;
        setFillSize(FillVal);
    }, [sliderValue]);
    function onAfterChange(value) {
        if (!marks || marks.length === 0) {
            setShowNum(true);
            window.setTimeout(() => {
                setShowNum(false);
            }, 1500);
        }
        onChange?.(value);
    }
    const pointList = useMemo(() => {
        if (marks) {
            return marks.sort((a, b) => a - b);
        }
        else {
            const points = [];
            const stepL = step || 1;
            for (let i = min; i < max; i += stepL) {
                points.push(i);
            }
            return points;
        }
    }, [marks, step, min, max]);
    function getValueByPosition(position) {
        const newPosition = position < min ? min : position > max ? max : position;
        let value = min;
        if (pointList.length && marks?.length) {
            value = nearest(pointList, newPosition);
        }
        else {
            const lengthPerStep = 100 / ((max - min) / (step || 1));
            const steps = Math.round(newPosition / lengthPerStep);
            value = steps * lengthPerStep * (max - min) * 0.01 + min;
        }
        return value;
    }
    const dragLockRef = useRef(0);
    const onTrackClick = (event) => {
        if (dragLockRef.current > 0)
            return;
        event.stopPropagation();
        const track = trackRef.current;
        if (!track)
            return;
        const sliderOffsetLeft = track.getBoundingClientRect().left;
        const position = ((event.clientX - sliderOffsetLeft) / Math.ceil(track.offsetWidth)) *
            (max - min) + min;
        const targetValue = getValueByPosition(position);
        setSliderValue(targetValue);
        onAfterChange(targetValue);
    };
    const renderThumb = (index) => {
        return (createElement(Thumb, { key: index, value: sliderValue, min: min, max: max, trackRef: trackRef, onDrag: (position, first, last) => {
                if (first) {
                    dragLockRef.current += 1;
                }
                const val = getValueByPosition(position);
                setSliderValue(val);
                if (last) {
                    onAfterChange(val);
                    window.setTimeout(() => {
                        dragLockRef.current -= 1;
                    }, 100);
                }
            } }));
    };
    return (createElement("div", { className: classNames(classPrefix, { 'has-marks': marks && marks.length }), ...otherProps },
        createElement("div", { className: `${classPrefix}-track-container`, onClick: onTrackClick },
            createElement("div", { className: `${classPrefix}-track`, ref: trackRef },
                createElement("div", { className: `${classPrefix}-fill`, style: {
                        width: fillSize,
                        left: 0,
                    } }, showNum && createElement("div", { className: `${classPrefix}-fill-num` }, sliderValue)),
                marks && (createElement(Ticks, { points: marks, min: min, max: max, value: sliderValue })),
                renderThumb(1))),
        marks && (createElement(Marks, { min: min, max: max, marks: marks }))));
};
ColorfulDragbar.displayName = 'ColorfulDragbar';
export default ColorfulDragbar;
